import { rusPassportCode } from '../../../../constants/constants';
import { checkNotEmpty } from '../../../../helpers/validators';
import { documentNumberPattern, passportNumberPattern } from './DocumentNumberField.constant';
export const checkDocumentNumberFormat = ({ value, documentType, }) => {
    const isCorrect = documentType === rusPassportCode ? passportNumberPattern.test(value) : documentNumberPattern.test(value);
    return isCorrect ? null : { type: 'lostfocus', message: 'Неверный формат' };
};
export const validateDocumentNumber = ({ value, required, documentType, }) => {
    return ((required && checkNotEmpty({ value, type: 'submit' })) ||
        (value && checkDocumentNumberFormat({ value, documentType })) ||
        null);
};
